import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

import menuData from '../data/menu.json';
import { menuApiUrl } from '../config/api';
import { buildMenuCategories } from '../utils/menu';

const MenuDataContext = createContext(null);
const getFallbackCategories = () => buildMenuCategories(menuData?.categories);

export function MenuDataProvider({ children }) {
  const [menuCategories, setMenuCategories] = useState(getFallbackCategories);
  const [loadingMenu, setLoadingMenu] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    let active = true;

    async function loadMenu() {
      try {
        const response = await fetch(menuApiUrl, { signal: controller.signal });
        if (!response.ok) throw new Error(response.statusText);

        const data = await response.json();
        const categories = buildMenuCategories(data?.data?.categories);
        if (active) setMenuCategories(categories.length ? categories : getFallbackCategories());
      } catch (error) {
        if (active) {
          console.error('Erro ao buscar cardápio do dashboard:', error);
          setMenuCategories(getFallbackCategories());
        }
      } finally {
        window.clearTimeout(timeout);
        if (active) setLoadingMenu(false);
      }
    }

    loadMenu();
    return () => {
      active = false;
      window.clearTimeout(timeout);
      controller.abort();
    };
  }, []);

  const value = useMemo(
    () => ({ menuCategories, loadingMenu }),
    [menuCategories, loadingMenu],
  );

  return <MenuDataContext.Provider value={value}>{children}</MenuDataContext.Provider>;
}

export function useMenuData() {
  const context = useContext(MenuDataContext);
  if (!context) throw new Error('useMenuData precisa de MenuDataProvider');
  return context;
}
